import React, { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ScrollRestoration } from '@/app/ScrollRestoration';
import { Box, Container } from '@mantine/core';
import { useElementSize } from '@mantine/hooks';
import clsx from 'clsx';
import layoutClasses from './Layout.module.scss';
import headerClasses from '@/components/Header/Header.module.scss';

// Тип под реальный ref из useElementSize
export type LayoutContext = {
    headerRef: ReturnType<typeof useElementSize<HTMLDivElement>>['ref'];
    headerH: number;
};

export const Layout: React.FC = () => {
    const [sticky, setSticky] = useState(false);


    const { ref: headerRef, height: headerH } = useElementSize<HTMLDivElement>();

    // throttled scroll с passive
    const ticking = useRef(false);
    useEffect(() => {
        const onScroll = () => {
            if (ticking.current) return;
            ticking.current = true;
            requestAnimationFrame(() => {
                setSticky(window.scrollY > 40);
                ticking.current = false;
            });
        };
        onScroll(); // первичная установка
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll as EventListener);
    }, []);

    return (
        <Box className={layoutClasses.page}>
            <ScrollRestoration />

            <header className={clsx(headerClasses.header, { [headerClasses.isSticky]: sticky })}>
                <Container className={headerClasses.headerContainer} ref={headerRef}>
                    <Header />
                </Container>
            </header>

            <Box
                component="main"
                className={layoutClasses.main}
                style={{ paddingTop: `calc(20px + ${headerH}px)` }}
            >
                <Outlet context={{ headerRef, headerH } satisfies LayoutContext} />
            </Box>

            <Footer />
        </Box>
    );
};
